import { render, staticRenderFns } from "./thirdOnePageDetail.vue?vue&type=template&id=5d6ead9c"
import script from "./thirdOnePageDetail.vue?vue&type=script&lang=js"
export * from "./thirdOnePageDetail.vue?vue&type=script&lang=js"
import style0 from "./thirdOnePageDetail.vue?vue&type=style&index=0&id=5d6ead9c&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6ead9c')) {
      api.createRecord('5d6ead9c', component.options)
    } else {
      api.reload('5d6ead9c', component.options)
    }
    module.hot.accept("./thirdOnePageDetail.vue?vue&type=template&id=5d6ead9c", function () {
      api.rerender('5d6ead9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/third/thirdOnePageDetail.vue"
export default component.exports